// extracted by mini-css-extract-plugin
module.exports = {"order-email-content":"order-email-content__f_tjO","order-email-subject":"order-email-subject__0dkDW","order-email-body":"order-email-body__Db30t"};